module.exports = __webpack_public_path__ + "img/empty.2e239d0e.png";